import PasswordRequirements from './PasswordRequirements'
export default PasswordRequirements
